import { SetAgentControlPanelType } from "../action-types/agentpanel.action.types";
import { AgentControlPanel } from "../actions/agentControlPanel.action";

interface AgentControlPanelSockState {
  agentControlPanel: any;
}

const initialState = {
  agentControlPanel: {},
};

const AgentControlPanelReducer = (
  state: AgentControlPanelSockState = initialState,
  action: AgentControlPanel
): AgentControlPanelSockState => {
  switch (action.type) {
    case SetAgentControlPanelType.SET_AGENT_CONTROL_PANEL:
      return {
        ...state,
        agentControlPanel: action.payload,
      };
    default:
      return state;
  }
};

export default AgentControlPanelReducer;
